import { ThemeProvider } from "@mui/material/styles"
import { createRoot } from "react-dom/client"

import theme from "../../mui-theme"
import SaveSessionNotesDialog from "./SaveSessionNotesDialog"

export function openSaveSessionNotesModal({
  axios,
  reportDate,
  accountOwnerId = null,
}) {
  if (typeof document === "undefined") {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    const container = document.createElement("div")
    document.body.appendChild(container)
    const root = createRoot(container)

    const finish = (saved) => {
      root.unmount()
      container.remove()
      resolve(Boolean(saved))
    }

    root.render(
      <ThemeProvider theme={theme}>
        <SaveSessionNotesDialog
          open
          axios={axios}
          reportDate={reportDate}
          accountOwnerId={accountOwnerId}
          onSaved={(data) => finish(data)}
          onClose={() => finish(false)}
        />
      </ThemeProvider>
    )
  })
}
